import React, { useEffect } from 'react';
import { Engine, Scene } from 'react-babylonjs';
import { Vector3, Color4, WebRequest, Color3 } from '@babylonjs/core';
import { authHeaders } from '../services/httpSvc';
import ScaledModelWithProgress from './ScaledModelWithProgress';

// adapted from https://github.com/brianzinn/react-babylonjs/blob/master/stories/babylonjs/Models/model.stories.js

const ObjViewer = (props) => {
  let model = props.model;
  
  const onModelLoaded = (model) => {
    console.log(model);
  };
  
  useEffect(() => {
    WebRequest.CustomRequestHeaders.Authorization = authHeaders()?.Authorization;
  }, [])

  return (
    <div>
      <Engine antialias adaptToDeviceRatio={false} canvasId="babylonJS">
        <Scene clearColor={Color4.FromInts(0, 0, 0, 0)}>
          <arcRotateCamera
            noRotationConstraint={true}
            upperBetaLimit={Math.PI / 2}
            lowerBetaLimit={Math.PI / 2}
            name="camera1"
            alpha={Math.PI / 2}
            beta={Math.PI / 2}
            radius={1.8}
            lowerRadiusLimit={1.8}
            upperRadiusLimit={1.8}
            minZ={0}
            target={new Vector3(0, 0.11, 0)}
          />
          <hemisphericLight name="light1" intensity={1} direction={Vector3.Up()} />

          {model && (
            <ScaledModelWithProgress
              key={model.sceneFilename}
              rootUrl={model.rootUrl}
              sceneFilename={model.sceneFilename}
              center={new Vector3(0, 0.3, 0)}
              position={new Vector3(0, 0, 0)}
              onModelLoaded={onModelLoaded}
              progressBarColor={Color3.FromInts(168, 99, 255)}
              scaleTo={1}
            />
          )}
        </Scene>
      </Engine>
    </div>
  );
};

export default ObjViewer;
